module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_13.b1fe17d1.jpg";